import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { Draggable } from './Draggable';
import { Question } from '../../../../types/faq';

type DroppableProps = {
  title: string;
  items: Question[];
  columnId: 'category' | 'questions';
  moveItem: (
    itemColumnId: 'category' | 'questions',
    itemIndex: number,
    columnId: 'category' | 'questions',
    hoverIndex: number,
  ) => void;
};

export const Droppable: FC<DroppableProps> = ({ title, columnId, items, moveItem }) => {
  return (
    <Box sx={{ height: '100%' }}>
      <Typography variant="subtitle2" align="center" sx={{ pb: 0.5, mb: 1, borderBottom: 1, borderColor: 'divider' }}>
        {title}
      </Typography>
      {items.length === 0 && (
        <Draggable
          key={1}
          id="1"
          text="Перетащите вопрос в область"
          index={0}
          disabled
          columnId={columnId}
          moveItem={moveItem}
        />
      )}
      {items.map((item, index) => (
        <Draggable key={item.id} id={item.id} text={item.title} index={index} columnId={columnId} moveItem={moveItem} />
      ))}
    </Box>
  );
};
